import { configureStore } from "@reduxjs/toolkit";

import dashboardSlice from "./Dashboard_Slice";
import AdminSlice from "./Admin_Slice";
import UserSlice from "./Users_Slice"
import statisticsSlice from"./statisticsSlice"
import ReservationsSlice from "./Reservations_Slice"
import PackegessAutocompleteSlice  from "./Package_AutoComplete"
import settingsSlice from "./settings_Slice"
import ExtraObjectsSlice from "./ExtraObjects_Slice"


export const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
    Admin: AdminSlice,
    Users:UserSlice,
    statistics :statisticsSlice,
    Reservations:ReservationsSlice,
    PackegesAutocomplete :PackegessAutocompleteSlice,
    settings :settingsSlice,
    ExtraObjects :ExtraObjectsSlice

  }
});
